// import { React, useState, useEffect } from 'react';
// import { useDispatch } from 'react-redux';
// import { updateTableActions } from '../../store/update-table-slice';
// import { Grid, TextField, Box, Button, Paper, Stack, FormControl, FormControlLabel, Checkbox, Typography, FormHelperText } from '@mui/material';
// import { ArrowForwardIos } from '@mui/icons-material';
// import axios from 'axios';
// import { HiOutlineCurrencyRupee } from "react-icons/hi2";
// import '../../App.css'
// import Popup from '../Popup';
// import LeaveDataMaster from './LeaveDataMaster';
// import Notification from '../Notification';
// import { useNavigate } from 'react-router-dom';

// const initialFValues = {
//   id: 0,
//   department: '',
//   designation: '',
//   ctc: '',
//   basic: '',
//   amount: '',
//   isEmployeeActive: false,
//   effectiveDate: '',
// }

// const RequiredLabel = ({ label }) => (
//   <span>
//     {label}
//     <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
//   </span>
// );

// function EmployeeSalaryForm(props) {
//   const [values, setValues] = useState(initialFValues);
//   const [errors, setErrors] = useState({});
//   const [openPopup, setOpenPopup] = useState(false);
//   const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' });
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [shouldCloseModal, setShouldCloseModal] = useState(false);

//   useEffect(() => {
//     if (notify.isOpen && notify.type === 'success') {
//       // Set flag to close modal after a short delay
//       const timer = setTimeout(() => {
//         setShouldCloseModal(true);
//       }, 500);
      
//       return () => clearTimeout(timer);
//     }
//   }, [notify]);

//   useEffect(() => {
//     if (shouldCloseModal) {
//       // Call the parent's function to close the modal if it exists
//       if (props.onCloseModal) {
//         props.onCloseModal();
//       }
//       // Also close the internal popup if it's open
//       setOpenPopup(false);
//       setShouldCloseModal(false);
//     }
//   }, [shouldCloseModal, props.onCloseModal]);

//   const validate = () => {
//     let temp = {};
//     //temp.effectiveDate = values.effectiveDate ? "" : "This field is required.";
    
//     if (props.salCompFetchID === 9999) {
//       temp.department = values.department ? "" : "This field is required.";
//       temp.designation = values.designation ? "" : "This field is required.";
//       temp.ctc = values.ctc ? (isNaN(parseFloat(values.ctc)) ? "CTC must be a numeric value." : "") : "This field is required.";
//       temp.basic = values.basic ? (isNaN(parseFloat(values.basic)) ? "Basic must be a numeric value." : "") : "This field is required.";
//     } else {
//       temp.amount = values.amount ? (isNaN(parseFloat(values.amount)) ? "Amount must be a numeric value." : "") : "This field is required.";
//     }
    
//     setErrors({ ...temp });
//     return Object.values(temp).every(x => x === "");
//   }

//   const resetForm = () => {
//     setValues(initialFValues);
//     setErrors({});
//     setNotify({ isOpen: false, message: '', type: '' });
//   }

//   const convertToDefEventPara = (name, value) => ({
//     target: {
//       name: name,
//       value: value
//     }
//   });

//   useEffect(() => {
//     async function getEmployee() {
//       let API_URL = "";
//       if (props.salCompFetchID === 9999) {
//         setValues(initialFValues);
//         return;
//       }
//       if (props.fetch_id !== 9999 && props.salCompFetchID !== 9999) {
//         API_URL = `${process.env.REACT_APP_API_BASE_URL}/employee-master/get-sal-component/` + props.fetch_id + "/" + props.salCompFetchID + "/" + props.effectiveDate;
//       } else if (props.fetch_id === 9999 && props.salCompFetchID !== 9999) {
//         API_URL = `${process.env.REACT_APP_API_BASE_URL}/employee-master/get-sal-component/` + props.employeeID + "/" + props.salCompFetchID + "/" + props.effectiveDate;
//       }
//       try {
//         const salComponents = await axios.get(API_URL);
//         console.log("mahek", salComponents.data);
//         const editFValues = {
//           department: salComponents.data[0].department,
//           designation: salComponents.data[0].designation,
//           ctc: salComponents.data[0].ctc,
//           basic: salComponents.data[0].basic,
//           amount: salComponents.data[0].Amount,
//           isEmployeeActive: salComponents.data[0].IsActive,
//           effectiveDate: salComponents.data[0].contract_effective_date ? salComponents.data[0].contract_effective_date.split('T')[0] : '',
//         }
//         console.log("editFValues", editFValues);
//         setValues(editFValues);
//       } catch (e) {
//         console.log(e);
//       }
//     }
//     getEmployee();
//   }, [props.fetch_id, props.salCompFetchID, props.effectiveDate, props.employeeID]);

//   function handleInputChange(e) {
//     const { name, value } = e.target;
//     console.log("mahesh Singh",value, typeof value);
//     setValues({
//       ...values,
//       [name]: value
//     });

//     if (errors[name]) {
//       setErrors({
//         ...errors,
//         [name]: ''
//       });
//     }

//     if (notify.isOpen) {
//       setNotify({ isOpen: false, message: '', type: '' });
//     }
//   }

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (validate()) {
//       let API_URL = '';
//       if (props.salCompFetchID === 9999 && props.fetch_id === 9999) {
//         values.id = props.employeeID;
//         API_URL = `${process.env.REACT_APP_API_BASE_URL}/employee-master/add-employee-salary`;
//       } else if (props.salCompFetchID === 9999 && props.fetch_id !== 9999) {
//         values.id = props.fetch_id;
//         API_URL = `${process.env.REACT_APP_API_BASE_URL}/employee-master/add-employee-salary`;
//       } else {
//         values.id = props.fetch_id;
//         API_URL = `${process.env.REACT_APP_API_BASE_URL}/employee-master/edit-employee-salary/` + props.salCompFetchID;
//       }
//       axios.post(API_URL, values)
//         .then(function (response) {
//           if (response.status === 200) {
//             setNotify({
//               isOpen: true,
//               message: props.salCompFetchID === 9999 ? 'Successfully added' : 'Successfully updated',
//               type: 'success'
//             });
//             dispatch(updateTableActions.startUpdateEmpSalComponents());
//             setErrors({});
//           }
//         })
//         .catch(function (e) {
//           if (e.response && e.response.status === 401) {
//             setNotify({
//               isOpen: true,
//               message: 'Session Expired!',
//               type: 'error'
//             });
//             setTimeout(() => {
//               navigate('/');
//             }, 1000);
//           } else if (e.response && e.response.data && (e.response.data.err_message || e.response.data.message)) {
//             setNotify({
//               isOpen: true,
//               message: e.response.data.err_message || e.response.data.message,
//               type: 'error'
//             });
//           } else {
//             setNotify({
//               isOpen: true,
//               message: 'An error occurred. Please try again.',
//               type: 'error'
//             });
//           }
//         });
//     }
//   }

//   return (
//     <Box sx={{ display: "flex", justifyContent: "center", margin: "10px", marginTop: "-30px", padding: "50px", fontWeight: "500px" }}>
//       <Paper elevation={5} sx={{ width: "500px" }}>
//         <Grid className="form-title" container spacing={2}>
//           <Grid item>
//             <Typography variant="h5" sx={{ textAlign: "center", margin: 5 }}>
//               {props.salCompFetchID === 9999 ? "ADD EMPLOYEE SALARY" : "MODIFY EMPLOYEE SALARY"}
//             </Typography>
//           </Grid>
//           <Grid item>
//             <HiOutlineCurrencyRupee style={{ marginLeft: "-30px" }} size={40} sx={{ height: 45, width: 45 }} />
//           </Grid>
//         </Grid>
//         <form className="classes.root" autoComplete="off" onSubmit={handleSubmit}>
//           <Stack spacing={2} sx={{ margin: "30px" }}>
//             <Stack className="form-input-row" direction="row" spacing={2}>
//               {props.salCompFetchID === 9999 &&
//                 <TextField
//                   variant="outlined"
//                   name="department"
//                   label={<RequiredLabel label="Department" />}
//                   size="small"
//                   value={values.department}
//                   onChange={handleInputChange}
//                   {...(errors.department && { error: true, helperText: errors.department })}
//                 />}
//               {props.salCompFetchID === 9999 &&
//                 <TextField
//                   variant="outlined"
//                   name="designation"
//                   label={<RequiredLabel label="Designation" />}
//                   size="small"
//                   value={values.designation}
//                   onChange={handleInputChange}
//                   {...(errors.designation && { error: true, helperText: errors.designation })}
//                 />}
//             </Stack>
//             <Stack className="form-input-row" direction="row" spacing={2}>
//               {props.salCompFetchID === 9999 &&
//                 <TextField
//                   variant="outlined"
//                   name="ctc"
//                   label={<RequiredLabel label="CTC" />}
//                   size="small"
//                   value={values.ctc}
//                   onChange={handleInputChange}
//                   {...(errors.ctc && { error: true, helperText: errors.ctc })}
//                 />}
//               {props.salCompFetchID === 9999 &&
//                 <TextField
//                   variant="outlined"
//                   name="basic"
//                   label={<RequiredLabel label="Basic" />}
//                   size="small"
//                   value={values.basic}
//                   onChange={handleInputChange}
//                   {...(errors.basic && { error: true, helperText: errors.basic })}
//                 />}
//             </Stack>
//             <Stack className="form-input-row" direction="row" spacing={2}>
//               {props.salCompFetchID === 9999 &&
//                 <FormControl>
//                   <FormControlLabel
//                     control={<Checkbox
//                       name="isEmployeeActive"
//                       color="primary"
//                       size="small"
//                       checked={values.isEmployeeActive}
//                       onChange={e => handleInputChange(convertToDefEventPara("isEmployeeActive", e.target.checked))}
//                     />}
//                     label="Active Employee"
//                   />
//                 </FormControl>}
//               <FormControl error={!!errors.effectiveDate}>
//                 <TextField
//                   variant="outlined"
//                   className="date-picker"
//                   type="date"
//                   size="small"
//                   id="date-picker"
//                   label="Effective Date" 
//                   name="effectiveDate"
//                   value={values.effectiveDate}
//                   onChange={handleInputChange}
//                   InputLabelProps={{ shrink: true }}
//                   {...(errors.effectiveDate && { error: true, helperText: errors.effectiveDate })}
//                 />
//                 {errors.effectiveDate && <FormHelperText>{errors.effectiveDate}</FormHelperText>}
//               </FormControl>
//             </Stack>
//             {props.salCompFetchID !== 9999 &&
//               <TextField
//                 variant="outlined"
//                 name="amount"
//                 label={<RequiredLabel label={props.component ? props.component : "Amount"} />}
//                 size="small"
//                 value={values.amount}
//                 onChange={handleInputChange}
//                 {...(errors.amount && { error: true, helperText: errors.amount })}
//               />}
//             <Grid container className="space-evenly">
//               <Grid item>
//                 <Button className="form-btn" variant="contained" color="error" disableElevation onClick={resetForm}>Reset</Button>
//               </Grid>
//               <Grid item>
//                 <Button className="form-btn" variant="contained" color="success" type="submit" disableElevation>
//                   {props.salCompFetchID === 9999 ? 'Submit' : 'Update'}
//                 </Button>
//               </Grid>
//             </Grid>
//           </Stack>
//           {props.salCompFetchID === 9999 && (
//             <Stack className="end-align">
//               <Button className="form-btn" variant="outlined" onClick={() => setOpenPopup(true)} endIcon={<ArrowForwardIos />} >Next</Button>
//             </Stack>
//           )}
//         </form>
//         <Popup
//           title="Company Bank Accounts Form"
//           openPopup={openPopup}
//           setOpenPopup={setOpenPopup}
//         >
//           <LeaveDataMaster employeeID={props.employeeID} fetch_id={9999} />
//         </Popup>
//       </Paper>
//       <Notification
//         notify={notify}
//         setNotify={setNotify}
//       />
//     </Box>
//   )
// }

// export default EmployeeSalaryForm;


import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateTableActions } from '../../store/update-table-slice';
import {
  Grid, TextField, Box, Button, Paper, Stack,
  FormControl, FormControlLabel, Checkbox,
  Typography, FormHelperText
} from '@mui/material';
import { ArrowForwardIos } from '@mui/icons-material';
import axios from 'axios';
import { HiOutlineCurrencyRupee } from "react-icons/hi2";
import '../../App.css'
import Popup from '../Popup';
import LeaveDataMaster from './LeaveDataMaster';
import Notification from '../Notification';
import { useNavigate } from 'react-router-dom';

const initialFValues = {
  id: 0,
  department: '',
  designation: '',
  ctc: '',
  basic: '',
  amount: '',
  isEmployeeActive: true,
  effectiveDate: '',
}

const RequiredLabel = ({ label }) => (
  <span>
    {label}
    <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
  </span>
);

function EmployeeSalaryForm(props) {
  const isEditStructure = !!props.isEditStructure;
  const showStructureFields = props.salCompFetchID === 9999 || isEditStructure;

  const buildValuesFromInitial = (iv = {}) => ({
    ...initialFValues,
    department: iv.department || '',
    designation: iv.designation || '',
    ctc: iv.ctc != null && iv.ctc !== '' ? String(iv.ctc) : '',
    basic: iv.basic != null && iv.basic !== '' ? String(iv.basic) : '',
    isEmployeeActive: iv.isEmployeeActive !== undefined ? !!iv.isEmployeeActive : true,
    effectiveDate: iv.effectiveDate || '',
  });

  const [values, setValues] = useState(() =>
    props.initialValues ? buildValuesFromInitial(props.initialValues) : initialFValues
  );
  const [errors, setErrors] = useState({});
  const [openPopup, setOpenPopup] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [shouldCloseModal, setShouldCloseModal] = useState(false);

  useEffect(() => {
    if (notify.isOpen && notify.type === 'success') {
      const timer = setTimeout(() => {
        setShouldCloseModal(true);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [notify]);

  useEffect(() => {
    if (shouldCloseModal) {
      if (props.onCloseModal) {
        props.onCloseModal();
      }
      setOpenPopup(false);
      setShouldCloseModal(false);
    }
  }, [shouldCloseModal, props.onCloseModal]);

  // Validation function to check required and numeric fields
  const validate = () => {
    let temp = {};
    if (showStructureFields) {
      temp.department = values.department ? "" : "This field is required.";
      temp.designation = values.designation ? "" : "This field is required.";
      temp.ctc = values.ctc ? (isNaN(parseFloat(values.ctc)) ? "CTC must be a numeric value." : "") : "This field is required.";
      temp.basic = values.basic ? (isNaN(parseFloat(values.basic)) ? "Basic must be a numeric value." : "") : "This field is required.";
      temp.effectiveDate = values.effectiveDate ? "" : "This field is required.";
    } else {
      temp.amount = values.amount ? (isNaN(parseFloat(values.amount)) ? "Amount must be a numeric value." : "") : "This field is required.";
    }
    setErrors({ ...temp });
    return Object.values(temp).every(x => x === "");
  }

  const resetForm = () => {
    if (props.initialValues) {
      setValues(buildValuesFromInitial(props.initialValues));
    } else {
      setValues(initialFValues);
    }
    setErrors({});
    setNotify({ isOpen: false, message: '', type: '' });
  }

  const convertToDefEventPara = (name, value) => ({
    target: {
      name: name,
      value: value
    }
  });

  // Fetch data on props changes to initialize form values
  useEffect(() => {
    async function getEmployee() {
      if (isEditStructure || (props.salCompFetchID === 9999 && props.initialValues)) {
        setValues(buildValuesFromInitial(props.initialValues || {}));
        return;
      }
      let API_URL = "";
      if (props.salCompFetchID === 9999) {
        setValues(initialFValues);
        return;
      }
      if (props.fetch_id !== 9999 && props.salCompFetchID !== 9999) {
        API_URL = `${process.env.REACT_APP_API_BASE_URL}/employee-master/get-sal-component/${props.fetch_id}/${props.salCompFetchID}/${props.effectiveDate}`;
      } else if (props.fetch_id === 9999 && props.salCompFetchID !== 9999) {
        API_URL = `${process.env.REACT_APP_API_BASE_URL}/employee-master/get-sal-component/${props.employeeID}/${props.salCompFetchID}/${props.effectiveDate}`;
      }
      try {
        const salComponents = await axios.get(API_URL);
        if (salComponents.data && salComponents.data.length > 0) {
          const s = salComponents.data[0];
          setValues({
            department: s.department || '',
            designation: s.designation || '',
            ctc: s.ctc != null ? String(s.ctc) : '',
            basic: s.basic != null ? String(s.basic) : '',
            amount: s.Amount != null ? String(s.Amount) : '',
            isEmployeeActive: s.IsActive || false,
            effectiveDate: s.contract_effective_date ? s.contract_effective_date.split('T')[0] : '',
          });
        }
      } catch (e) {
        console.error(e);
      }
    }
    getEmployee();
  }, [props.fetch_id, props.salCompFetchID, props.effectiveDate, props.employeeID, isEditStructure, props.initialValues]);

  // Handle input changes and store all values as strings except checkbox which is boolean
  function handleInputChange(e) {
    const { name, value, type, checked } = e.target;
    let newValue = value;

    // Handle checkbox separately
    if (type === 'checkbox') {
      setValues({
        ...values,
        [name]: checked
      });
      return;
    }

    // Define text-only fields (only letters and spaces allowed)
    const textOnlyFields = ['department', 'designation'];
    
    // Define decimal fields (digits with optional decimal point)
    const decimalFields = ['ctc', 'basic', 'amount'];
    
    // Apply input restrictions
    if (textOnlyFields.includes(name)) {
      // Only allow letters, spaces, apostrophes, and hyphens
      newValue = value.replace(/[^a-zA-Z\s'-]/g, '');
    } else if (decimalFields.includes(name)) {
      // Allow digits and decimal point
      newValue = value.replace(/[^\d.]/g, '');
      // Ensure only one decimal point
      const parts = newValue.split('.');
      if (parts.length > 2) {
        newValue = parts[0] + '.' + parts.slice(1).join('');
      }
    }

    setValues({
      ...values,
      [name]: newValue
    });

    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
    if (notify.isOpen) {
      setNotify({ isOpen: false, message: '', type: '' });
    }
  }

  // Submit handler converts numeric strings to numbers before sending, validates form
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      let API_URL = '';
      let payload = { ...values };
      const employeeId = props.fetch_id === 9999 ? props.employeeID : props.fetch_id;

      if (isEditStructure) {
        const originalDate =
          props.originalEffectiveDate ||
          props.initialValues?.originalEffectiveDate ||
          values.effectiveDate;
        API_URL = `${process.env.REACT_APP_API_BASE_URL}/employee-master/update-employee-salary-structure/${employeeId}`;
        payload = {
          department: values.department,
          designation: values.designation,
          original_contract_effective_date: originalDate,
          contract_effective_date: values.effectiveDate,
          new_contract_effective_date: values.effectiveDate,
          ctc: parseFloat(values.ctc),
          basic: parseFloat(values.basic),
          isEmployeeActive: values.isEmployeeActive
        };
      } else if (props.salCompFetchID === 9999 && props.fetch_id === 9999) {
        payload.id = props.employeeID;
        API_URL = `${process.env.REACT_APP_API_BASE_URL}/employee-master/add-employee-salary`;
      } else if (props.salCompFetchID === 9999 && props.fetch_id !== 9999) {
        payload.id = props.fetch_id;
        API_URL = `${process.env.REACT_APP_API_BASE_URL}/employee-master/add-employee-salary`;
      } else {
        payload.id = props.fetch_id;
        API_URL = `${process.env.REACT_APP_API_BASE_URL}/employee-master/edit-employee-salary/${props.salCompFetchID}`;
      }

      // Convert numeric fields before submit (add / component edit paths)
      if (!isEditStructure) {
        if (props.salCompFetchID === 9999) {
          payload.ctc = parseFloat(payload.ctc);
          payload.basic = parseFloat(payload.basic);
        } else {
          payload.amount = parseFloat(payload.amount);
        }
      }

      axios.post(API_URL, payload)
        .then(function (response) {
          if (response.status >= 200 && response.status < 300) {
            setNotify({
              isOpen: true,
              message: isEditStructure
                ? (response.data?.message || 'Successfully updated')
                : (props.salCompFetchID === 9999 ? 'Successfully added' : 'Successfully updated'),
              type: 'success'
            });
            dispatch(updateTableActions.startUpdateEmpSalComponents());
            setErrors({});
            // Call onSuccess callback immediately to refresh table
            if (props.onSuccess) {
              props.onSuccess();
            }
          }
        })
        .catch(function (e) {
          if (e.response && e.response.status === 401) {
            setNotify({
              isOpen: true,
              message: 'Session Expired!',
              type: 'error'
            });
            setTimeout(() => {
              navigate('/');
            }, 1000);
          } else if (e.response && e.response.data && (e.response.data.err_message || e.response.data.message)) {
            setNotify({
              isOpen: true,
              message: e.response.data.err_message || e.response.data.message,
              type: 'error'
            });
          } else {
            setNotify({
              isOpen: true,
              message: 'An error occurred. Please try again.',
              type: 'error'
            });
          }
        });
    }
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "center", margin: "10px", marginTop: "-30px", padding: "50px", fontWeight: "500px" }}>
      <Paper elevation={5} sx={{ width: "500px" }}>
        <Grid className="form-title" container spacing={2}>
          <Grid item>
            <Typography variant="h5" sx={{ textAlign: "center", margin: 5 }}>
              {props.salCompFetchID === 9999 ? "ADD EMPLOYEE SALARY" : "MODIFY EMPLOYEE SALARY"}
            </Typography>
          </Grid>
          <Grid item>
            <HiOutlineCurrencyRupee style={{ marginLeft: "-30px" }} size={40} sx={{ height: 45, width: 45 }} />
          </Grid>
        </Grid>
        <form className="classes.root" autoComplete="off" onSubmit={handleSubmit}>
          <Stack spacing={2} sx={{ margin: "30px" }}>
            <Stack className="form-input-row" direction="row" spacing={2}>
              {showStructureFields &&
                <>
                  <TextField
                    variant="outlined"
                    name="department"
                    label={<RequiredLabel label="Department" />}
                    size="small"
                    value={values.department}
                    onChange={handleInputChange}
                    {...(errors.department && { error: true, helperText: errors.department })}
                  />
                  <TextField
                    variant="outlined"
                    name="designation"
                    label={<RequiredLabel label="Designation" />}
                    size="small"
                    value={values.designation}
                    onChange={handleInputChange}
                    {...(errors.designation && { error: true, helperText: errors.designation })}
                  />
                </>
              }
            </Stack>
            <Stack className="form-input-row" direction="row" spacing={2}>
              {showStructureFields &&
                <>
                  <TextField
                    variant="outlined"
                    name="ctc"
                    label={<RequiredLabel label="CTC" />}
                    size="small"
                    value={values.ctc}
                    onChange={handleInputChange}
                    {...(errors.ctc && { error: true, helperText: errors.ctc })}
                  />
                  <TextField
                    variant="outlined"
                    name="basic"
                    label={<RequiredLabel label="Basic" />}
                    size="small"
                    value={values.basic}
                    onChange={handleInputChange}
                    {...(errors.basic && { error: true, helperText: errors.basic })}
                  />
                </>
              }
            </Stack>
            <Stack className="form-input-row" direction="row" spacing={2}>
              {showStructureFields &&
                <FormControl>
                  <FormControlLabel
                    control={<Checkbox
                      name="isEmployeeActive"
                      color="primary"
                      size="small"
                      checked={values.isEmployeeActive}
                      onChange={e => handleInputChange(convertToDefEventPara("isEmployeeActive", e.target.checked))}
                    />}
                    label="Active Employee"
                  />
                </FormControl>
              }
              <FormControl error={!!errors.effectiveDate}>
                <TextField
                  variant="outlined"
                  className="date-picker"
                  type="date"
                  size="small"
                  id="date-picker"
                  label="Effective Date"
                  name="effectiveDate"
                  value={values.effectiveDate}
                  onChange={handleInputChange}
                  disabled={!!props.disableEffectiveDate}
                  InputLabelProps={{ shrink: true }}
                  {...(errors.effectiveDate && { error: true, helperText: errors.effectiveDate })}
                />
                {errors.effectiveDate && <FormHelperText>{errors.effectiveDate}</FormHelperText>}
              </FormControl>
            </Stack>
            {!showStructureFields &&
              <TextField
                variant="outlined"
                name="amount"
                label={<RequiredLabel label={props.component ? props.component : "Amount"} />}
                size="small"
                value={values.amount}
                onChange={handleInputChange}
                {...(errors.amount && { error: true, helperText: errors.amount })}
              />}
            <Grid container className="space-evenly">
              <Grid item>
                <Button className="form-btn" variant="contained" color="error" disableElevation onClick={resetForm}>Reset</Button>
              </Grid>
              <Grid item>
                <Button className="form-btn" variant="contained" color="success" type="submit" disableElevation>
                  {props.salCompFetchID === 9999 ? 'Submit' : 'Update'}
                </Button>
              </Grid>
            </Grid>
          </Stack>
          {props.salCompFetchID === 9999 && !isEditStructure && (
            <Stack className="end-align">
              <Button className="form-btn" variant="outlined" onClick={() => setOpenPopup(true)} endIcon={<ArrowForwardIos />}>Next</Button>
            </Stack>
          )}
        </form>
        <Popup
          title="Company Bank Accounts Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <LeaveDataMaster employeeID={props.employeeID} fetch_id={9999} />
        </Popup>
      </Paper>
      <Notification
        notify={notify}
        setNotify={setNotify}
      />
    </Box>
  );
}

export default EmployeeSalaryForm;
